import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProviderMultiHedgeComponent } from '../provider-multi-hedge/provider-multi-hedge.component';

@Component({
  selector: 'app-provider-multi-hedge-group',
  templateUrl: './provider-multi-hedge-group.component.html',
  styleUrls: ['./provider-multi-hedge-group.component.scss']
})
export class ProviderMultiHedgeGroupComponent {
  @Input() public groupName: string;
  @Input() public hedgeMode = '';
  @Input() public setupForm: FormGroup;
  @Input() public volBased: boolean;
  @Input() public isCustomHedge = false;
  @Input() public cross: string;
  @Input({ required: true }) showExpiryDate: boolean;
  @Output() public fieldBlur = new EventEmitter();
  @ViewChildren(ProviderMultiHedgeComponent)
  public multiHedgeComponent: QueryList<ProviderMultiHedgeComponent>;

  public onElemBlur(): void {
    this.fieldBlur.emit();
  }
}
